"use client";

import { createClient } from "./client";

export const supabaseClient = createClient();
